var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecurring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 62,
    viewBox: "0 0 42 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.833984 9.77C0.873984 23.95 0.963984 49.25 0.963984 55.23C0.963984 61.21 4.91398 59.98 4.91398 59.98C4.91398 59.98 31.944 59.98 36.554 59.98C41.164 59.98 39.834 54.47 39.834 54.47C40.234 38.3 40.304 22.12 40.044 5.95C40.044 5.95 40.534 0 37.004 0C33.474 0 9.63399 0 9.63399 0L0.833984 9.77Z",
    fill: "#80BBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7833 15.3799C39.7433 29.5599 40.1433 48.9399 40.1433 54.9299C40.1433 60.9199 36.1933 59.6799 36.1933 59.6799C36.1933 59.6799 17.9733 59.6799 13.3633 59.6799",
    stroke: "#001B66",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4342 2.08008C11.3542 4.91008 11.2842 7.75008 11.2042 10.5801C8.43422 10.3401 6.58422 10.3801 3.82422 10.6901",
    stroke: "#001B66",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06445 29.9901C9.66445 26.0501 11.9345 22.3001 15.4045 20.3301C18.8745 18.3601 23.5145 18.4401 26.6745 20.8701",
    stroke: "#001B66",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7551 16.1401C28.5651 18.1401 28.9851 19.5701 29.4251 21.6801C29.4451 21.7601 29.4551 21.8601 29.4251 21.9301C29.3851 22.0201 29.2851 22.0601 29.1951 22.1001C26.9251 23.0901 25.7851 23.6701 23.4551 24.5001",
    stroke: "#001B66",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0739 29.2202C30.5939 33.1802 28.4439 37.0002 25.0339 39.0702C21.6239 41.1402 16.9839 41.2102 13.7539 38.8802",
    stroke: "#001B66",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2743 43.8502C12.4043 41.8802 11.4943 40.2602 10.9843 38.1602C10.9643 38.0802 10.9443 37.9902 10.9743 37.9102C11.0143 37.8202 11.1043 37.7702 11.1943 37.7302C13.4343 36.6702 14.5543 36.0602 16.8643 35.1602",
    stroke: "#001B66",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurring);
export default __webpack_public_path__ + "static/media/recurring.1409bb72660dc9d216443489eb9e1a7a.svg";
export { ForwardRef as ReactComponent };